'use strict';
const Backbone = require('dibs-backbone');
const Address = require('./Address');
const moment = require('moment');

module.exports = Backbone.AssociatedModel.extend({

    relations: [
        {
            key: 'sellerDetails',
            relatedModel: Backbone.AssociatedModel.extend(),
            type: Backbone.One
        },
        {
            key: 'address',
            relatedModel: Address,
            type: Backbone.One
        }
    ],

    getRegDateFormatted() {
        const regDateMomentObj = moment(this.get('buyerRegistrationDate'));
        return regDateMomentObj.format(
            (regDateMomentObj.year() === moment().year() ? 'MMMM, ' : '') + 'YYYY'
        );
    },

    isFollowingSeller() { return this.get('sellerDetails.followingSeller') === 'Y'; },
    isVerifiedPaymentInformation() { return this.get('verifiedPaymentInformation') === 'Y'; },
    isActiveBuyer() { return this.get('activeBuyer') === 'Y'; },
    isTrade() { return this.get('tradeBuyer') === 'Y'; }
});



// WEBPACK FOOTER //
// ./~/bunsen/models/BuyerProfile.es.js